import Button from "@edaz/edazkit/Button/index";
import { Check } from "@frui.ts/bootstrap";
import { preventDefault } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Form from "react-bootstrap/Form";
import { isFilterDirty, isFilterEmpty } from "../../utils/filters";
import { translateGeneral } from "../../utils/localizations";
import type ListViewModel from "../../viewModels/listViewModel";
import { IconType } from "@edaz/edazkit/Icon";

export interface FilterViewProps<TFilter> {
  vm: ListViewModel<any, any, any, TFilter>;
  children: React.ReactNode;
  customFilterButton?: React.ReactNode;
  customResetButton?: React.ReactNode;
}

function FilterView<TFilter>(props: FilterViewProps<TFilter>) {
  const { vm, children, customFilterButton, customResetButton } = props;

  let resetButton;

  if (customResetButton) {
    resetButton = customResetButton;
  } else if (isFilterDirty(vm.filter) || !isFilterEmpty(vm.filter)) {
    resetButton = (
      <Button iconLeft={IconType.Cross} variant="outline-danger" className="btn-form-height" type="reset">
        {translateGeneral("resetFilter")}
      </Button>
    );
  }

  <div className="flex text-right text-nowrap">
    {(isFilterDirty(vm.filter) || !isFilterEmpty(vm.filter)) && (
      <Button iconLeft={IconType.Cross} variant="outline-danger" className="btn-form-height" type="reset">
        {vm.translate("resetFilter")}
      </Button>
    )}
    <Button iconLeft={IconType.Search} className="btn-form-height" type="submit" disabled={vm.busyWatcher?.isBusy}>
      {vm.translate("search")}
    </Button>
  </div>;

  const hasFullText = vm.filter.hasOwnProperty("fullTextSearchEnabled");
  return (
    <Form
      className="mb-4"
      onSubmit={preventDefault(vm.applyFilterAndLoad)}
      onReset={preventDefault(vm.resetFilterAndLoad)}
      noValidate={true}>
      {children}
      <div className="mt-2 row">
        {hasFullText && !isFilterEmpty(vm.filter) && (
          <div className="order-lg-2 col-lg-auto">
            <Check
              className="mt-lg-3 mb-3 mb-lg-0"
              target={vm.filter as any}
              property="fullTextSearchEnabled"
              disabled={isFilterEmpty(vm.filter)}
              custom
              label={
                <>
                  <span>{translateGeneral("allowFullTextSearch")}</span>
                  {(vm.filter as any).fullTextSearchEnabled && (
                    <span className="pl-4 font-size-sm text-muted">{translateGeneral("noticeFullTextSearch")}</span>
                  )}
                </>
              }
            />
          </div>
        )}
        <div className="col-lg-auto">
          <ButtonToolbar className="mt-2">
            {customFilterButton ?? (
              <Button iconLeft={IconType.Search} className="btn-form-height" type="submit" disabled={!isFilterDirty(vm.filter)}>
                {translateGeneral("filter")}
              </Button>
            )}
            {resetButton}
          </ButtonToolbar>
        </div>
      </div>
    </Form>
  );
}

export default observer(FilterView);
